import cn from 'classnames'

const ConveyanceTableBody = ({
    parties,
    getPartyMergeCount,
    setSelectedParty,
    chainHeaders,
    sumConveyances,
}) => {
    
    return (
        
        <tbody className="ConveyanceTableBody">
            
            {!parties?.length && (
                <tr>
                    <td className="!text-left" colSpan="6">No parties found.</td>
                </tr>
            )}
            
            {parties.map((p, x) => {
                
                const mergeCount = getPartyMergeCount(p.id)
                
                return (
                    
                    <tr key={p.id}>
                        
                        <td
                            data-x={x}
                            className="bg-base-200">
                            <div
                                className="flex gap-2 cursor-pointer justify-end"
                                onClick={() => setSelectedParty(p.id)}>
                                <div
                                    className="truncate min-w-32 max-w-60"
                                    data-tooltip-id="defaut-tip"
                                    data-tooltip-content={p.name}>
                                    {p.name}
                                </div>
                                {mergeCount > 1 &&
                                    <div
                                        className="badge badge-primary w-5 p-0
                                            tooltip tooltip-right tooltip-primary"
                                        data-tip="The amount of parties merged with this name">
                                        {mergeCount}
                                    </div>}
                            </div>
                        </td>
                        
                        {chainHeaders.map((type, y) => {
                            const sum = sumConveyances(p.conveyances, type)
                            
                            return <td
                                className={cn({ 'text-error': sum > 1 || sum < 0 })}
                                data-conveyance-type={type}
                                data-x={x}
                                data-y={y}
                                key={`sum-${type}`}>{sum}</td>
                        })}
                    
                    </tr>
                    
                )
                
            })}
        
        </tbody>
        
    )
    
}

export default ConveyanceTableBody
